const ItemisationAdjustment = (originalCost) => {
    return (val) => {
        let valid = false;
        let error = null;

        if (val) {
            valid = val.description !== '' && val.amount !== 0;

            if (valid === false) {
                error = 'Please enter an adjustment amount and description.';
            } else if (val.amount < (originalCost * -1)) {
                valid = false;
                error = 'The adjustment amount cannot be more than the original cost.';

            }
        } else {
            valid = true;
        }

        return [
            valid,
            error,
        ]
    }
}

export default ItemisationAdjustment;
